export default {
  appBar: 1000,
  drawer: 1100,
  dialog: 1200,
  dropdown: 1300,
  toast: 1400,
  tooltip: 1500
};